import React, { useEffect, useState } from "react";
import Form from "../../components/Form/Form";
import { useFormConfig } from "./ModuleFieldsConfig";
import { addModule, updateModule } from "../../services/ModuleService";
import { useLocation } from "react-router-dom";

function ModuleForm({ onClose }) {
  const { moduleForm } = useFormConfig();
  const location = useLocation();
  const { mode, module } = location.state || {};
  const [formData, setFormData] = useState(moduleForm.initialFormData);

useEffect(() => {
  if (mode === "update" && module) {
    setFormData({
      title: module.title || "",
      courseId:  Number(module.course_id) || null,
      description: module.description || "",
    });
  } else {
    setFormData(moduleForm.initialFormData);
  }
}, [mode, module]);
  const handleSubmit = async (moduleFormData) => {
    try {
      if (mode === "update" && module) {
        await updateModule(module.id, moduleFormData);
      } else {
        await addModule(moduleFormData);
      }
      onClose();
    } catch (error) {
      console.error("Error submitting module:", error);
    }
  };

  return (
    <Form 
      formTitle={mode === "update" ? "Update Module" : moduleForm.formTitle}
      initialFormData={formData}
      fieldConfig={moduleForm.fieldConfig}
      onSubmit={handleSubmit}
      onClose={onClose}
    />
  );
}

export default ModuleForm;